// SEO copy lives on /guide routes. Renders nothing.
const SeoContentSection = () => null;

export default SeoContentSection;
